import { DashboardRoutes } from './dashboard.routing';
import { provideRouter } from '@angular/router';

export const dashboardConfig = [provideRouter(DashboardRoutes)];
